import type { VideoModelConfig } from '../../types';

/** 即梦 3.5 Pro */
export const jimeng3_5Pro: VideoModelConfig = {
  id: '01KEDRYRXHC85CF8WK7N65AXJH',
  displayName: '即梦 3.5 Pro',
  defaults: {
    resolution: '720P',
    duration: 5,
  },
  resolutionOptions: [
    { label: '480P', value: '480P' },
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'options', options: [5, 10, 12] },
  capabilities: {},
  limits: {
    maxRefImages: 1,
  },
  /** 画布扩展（节点式业务专属字段，从画布 configs/jimeng-3.5-pro.ts 迁移） */
  canvas: {
    capabilities: {
      refVideo: false,
      refAudio: false,
      atMentionTabs: ['全能参考', '图生视频', '视频编辑', '视频延长'],
    },
    limits: {
      validateRefImageSize: true,
      promptMaxLength: 12000,
      maxRefImages: 1,
      refImageConstraints: {
        formats: ['jpeg', 'png', 'webp', 'bmp', 'tiff', 'gif'],
        maxFileSizeMB: 20,
        dimension: { min: 300, max: 6000 },
        aspectRatio: { min: 0.4, max: 2.5 },
      },
    },
  },
};
